











 


















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamDashHeader_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardAvatars_team"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "preferredName"
        }
      ],
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMembers",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InviteTeamMemberAvatar_teamMembers"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DashboardAvatar_teamMember"
        },
        (v0/*: any*/)
      ],
      "storageKey": "teamMembers(sortBy:\"preferredName\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamDashTeamMemberMenu_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node ).hash = "67f3e2ade5725432482156b4879785b8";

export default node;
